<template>
    <main-page>
        <b-card>
            Please wait redirecting to home page...
        </b-card>
    </main-page>
</template>

<script>
    export default {
        name: `home`,
        mounted() {
            localStorage.setItem(`dealer`, this.$route.params.dealer);
            localStorage.setItem(`session`, this.$route.params.sessionId);
            this.$store.commit(`setDealer`, this.$route.params.dealer);
            this.$store.commit(`setSession`, this.$route.params.sessionId);
            this.$router.push(`/`);
        }
    }
</script>

<style scoped>

</style>
